import i18next from 'i18next';

i18next.addResources('es_CL', 'CloseSession', {
  sessionClosed: 'Has cerrado sesión',
  close: 'Cerrar'
});
